import { ExclamationTriangleIcon } from '@radix-ui/react-icons'
import { Flex } from '@radix-ui/themes'
import { PlayWalletStatus } from 'shared/store/play-wallet'
import { NeonButton } from 'shared/ui/neon'
import { shortenAddress } from 'shared/utils/shorten-address'
import styles from '../neon-wallets.module.scss'

interface Props {
  status: PlayWalletStatus | null
  connectedAddress: string | null
  isLinking: boolean
  onLinkConnected: () => void
}

/** Explains why game actions are blocked for a connected wallet that is not linked. */
export const PlayWalletNotice: React.FC<Props> = ({
  status,
  connectedAddress,
  isLinking,
  onLinkConnected
}) => {
  if (!connectedAddress || status !== PlayWalletStatus.notLinked) return null

  const shortAddress = shortenAddress(connectedAddress)

  return (
    <Flex
      direction='column'
      gap='2'
      className={styles.notice}
    >
      <Flex
        align='center'
        gap='2'
      >
        <ExclamationTriangleIcon className={styles.noticeIcon} />
        <span className={styles.noticeTitle}>
          The connected wallet {shortAddress} is not linked to your account
        </span>
      </Flex>
      <span className={styles.noticeText}>
        Games are blocked for this wallet. Anything it plays is recorded for a
        separate anonymous account, and the wallet can then never be linked to
        yours. Link it first, or connect one of your wallets below.
      </span>
      <NeonButton
        type='button'
        color='pink'
        disabled={isLinking}
        onClick={onLinkConnected}
      >
        Link {shortAddress}
      </NeonButton>
    </Flex>
  )
}
